module.exports = __webpack_public_path__ + "static/webroll-dacb035564e804a0f74fc20e73e56a95.mp4";